import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { Song } from 'interfaces';

import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import SongsList from 'components/SongsList';
import Title from 'components/ui/Title';

import {
  Wrapper
} from './Songs.styles';


export interface AlbumProps {
  songs: Song[];
}

const Songs = ({ songs }: AlbumProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <Wrapper>
      <Title size="big" color="secondary">
        {intl.formatMessage({ id: 'songs.title' })}
      </Title>
      <p>
        {intl.formatMessage({ id: 'songs.description' }, {
          bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
        })}
      </p>
      <SongsList songs={songs} listType="all" />
    </Wrapper>
  );
};

export default Songs;
